import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const addAddressFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.addAddress, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
